<template>
    <div>
        <div class="ef-node-form">
            <div class="ef-node-form-header">
                编辑参数
            </div>
            <div class="ef-node-form-body">
                {{changeIdToName(node.name)}}<hr />
                <el-form :model="node" ref="dataForm" label-width="80px" v-show="type === 'node'">
                    <el-form-item v-for="(data,index) in node.dataarr" :key="index" :label="data.label" >
                        <el-select @change="unlocksavebtn('selectchange')" v-model="data.value" placeholder="请选择" v-if="data.label=='信号'"> 
                            <el-option  v-for="option in data.options" :key="option.value" :label="option.label" :value="option.value"> </el-option>
                        </el-select>
                        <el-input @input="unlocksavebtn" v-else v-model="data.value" style="width:100px" :disabled="(data.label=='U0'&&data.edit!=true) || (data.label=='U1')"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button :disabled="!savebtnDisable"  @click="showechart">显示图像</el-button>
                        <el-button :disabled="savebtnDisable" type="primary" icon="el-icon-check" @click="save">保存</el-button>
                    </el-form-item>
                </el-form>

                <el-form :model="line" ref="dataForm" label-width="80px" v-show="type === 'line'">
                    <el-form-item label="条件">
                        <el-input v-model="line.label"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-close">重置</el-button>
                        <el-button type="primary" icon="el-icon-check" @click="saveLine">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
           
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash'
    export default {
        data() {
            return {
                savebtnDisable:false,
                visible: true,
                // node 或 line
                type: 'node',
                node: {},
                line: {},
                data: {},
            }
        },
        methods: {
            /**
             * 表单修改，这里可以根据传入的ID进行业务信息获取
             * @param data
             * @param id
             */
            nodeInit(data, id) {
                this.type = 'node'
                this.data = data
                data.nodeList.filter((node) => {
                    if (node.id === id) {
                        this.node = cloneDeep(node)
                    }
                })
            },
            lineInit(line) {
                this.type = 'line'
                this.line = line
            },
            // 修改连线
            saveLine() {
                this.$emit('setLineLabel', this.line.from, this.line.to, this.line.label)
            },
            unlocksavebtn(item){
                this.savebtnDisable = false;
                // if(item==='selectchange'){
                //     this.showechart();
                // }
            },
            save(){
                
                this.savebtnDisable = true; 
                this.data.nodeList.filter((node) => {
                    if (node.id === this.node.id) {
                        node.name = this.node.name
                        node.left = this.node.left
                        node.top = this.node.top
                        node.ico = this.node.ico
                        node.state = this.node.state
                        node.dataarr = this.node.dataarr;
                        this.$emit('repaintEverything')
                    }
                })
            },
            showechart(){
                this.$parent.panelChangedialogVisible()
            }
        }
    }
</script>

<style>
    .el-node-form-tag {
        position: absolute;
        top: 50%;
        margin-left: -15px;
        height: 40px;
        width: 15px;
        /* background-color: #fbfbfb; */
        border: 1px solid rgb(220, 227, 232);
        border-right: none;
        z-index: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/ef/node_form.vue